import React from "react";

import FieldRAG_Icon from "../rag-icon";

export default function FieldRAG_InlineValueNotEmpty(props:any) {
    return (
        <React.Fragment>
            <div className="ui5-field-dropdown-inline-editable" onClick={props.onClick}>
                <FieldRAG_Icon className="fl-ac" option={props.option}/>
            </div>
            {props.children}
        </React.Fragment>
    )
}